import { Repository } from '../abstraction';
import { ReadonlyHttpApiRepository } from './readonly-http-api.repository';
import { ApiResourceLocation } from '../../data-access/types/api.location';
import { ApiDataAccess } from '../../data-access/api.data-access';
import { Dictionary } from '../../types/dictionary';

export abstract class HttpApiRepository<T, TResult, TLoadParams = undefined, TCrudParams = undefined> extends ReadonlyHttpApiRepository<TResult, TLoadParams> implements Repository<T, TResult, TLoadParams, TCrudParams> {

  protected constructor(dataAccess: ApiDataAccess,
                        path: string | string[]) {
    super(dataAccess, path);
  }

  create(value: T, params: TCrudParams): Promise<TResult> {
    const location: ApiResourceLocation = {
      path: this.path,
      pathParams: this.getCRUDPathParams(params)
    };
    return this.dataAccess.create(location, value);
  }
  update(value: T, params: TCrudParams): Promise<TResult> {
    const location: ApiResourceLocation = {
      path: this.path,
      pathParams: this.getCRUDPathParams(params)
    };
    return this.dataAccess.update(location, value);
  }
  patch(patch: Partial<T>, params: TCrudParams): Promise<TResult> {
    const location: ApiResourceLocation = {
      path: this.path,
      pathParams: this.getCRUDPathParams(params)
    };
    return this.dataAccess.patch(location, patch);
  }
  delete(params: TCrudParams): Promise<TResult> {
    const location: ApiResourceLocation = {
      path: this.path,
      pathParams: this.getCRUDPathParams(params)
    };
    return this.dataAccess.delete(location);
  }

  protected abstract getCRUDPathParams(params: TCrudParams): Dictionary<unknown> | undefined;
}
